class ProjectConfig { 
    static todoProjectId = "2759e306-43f7-49e6-98ba-c8e10e7f8a9e";
    static todoProjectItemType = 1;
}

export default ProjectConfig;